/**
 * Parent Service - API client for a parent's linked children,
 * their academics, and assignment performance
 */
import api from '../utils/api';

const parentService = {
  getChildren: async () => {
    try {
      return await api.get('/api/parent/children');
    } catch (error) {
      console.error('Error fetching children:', error);
      throw error;
    }
  },

  getAnnouncements: async () => {
    try {
      return await api.get('/api/parent/announcements');
    } catch (error) {
      console.error('Error fetching parent announcements:', error);
      throw error;
    }
  },

  getChildOverview: async (childId, termId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/overview`, { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching child overview:', error);
      throw error;
    }
  },

  getChildGrades: async (childId, termId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/grades`, { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching child grades:', error);
      throw error;
    }
  },

  getChildFees: async (childId, termId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/fees`, { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching child fees:', error);
      throw error;
    }
  },

  getChildAttendance: async (childId, termId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/attendance`, { params: { days: 30, term_id: termId } });
    } catch (error) {
      console.error('Error fetching child attendance:', error);
      throw error;
    }
  },

  getChildEnrollmentStatus: async (childId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/enrollment-status`);
    } catch (error) {
      console.error('Error fetching child enrollment status:', error);
      throw error;
    }
  },

  getChildHostelStatus: async (childId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/hostel/status`);
    } catch (error) {
      console.error('Error fetching child hostel status:', error);
      throw error;
    }
  },

  getChildTransportStatus: async (childId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/transport/status`);
    } catch (error) {
      console.error('Error fetching child transport status:', error);
      throw error;
    }
  },

  getChildAssignments: async (childId, termId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/assignments`, { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching child assignments:', error);
      throw error;
    }
  },

  getChildAssignmentMetrics: async (childId, termId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/assignment-metrics`, { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching child assignment metrics:', error);
      throw error;
    }
  },

  getChildLibraryLoans: async (childId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/library/loans`);
    } catch (error) {
      console.error('Error fetching child library loans:', error);
      throw error;
    }
  },

  getChildLibraryFines: async (childId) => {
    try {
      return await api.get(`/api/parent/child/${childId}/library/fines`);
    } catch (error) {
      console.error('Error fetching child library fines:', error);
      throw error;
    }
  }
};

export default parentService;
